module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c9e88af1d675b80aff340cebfce8ecbc.png";